import React from "react";
import { useNavigate } from "react-router-dom";
import { FaArrowLeft } from "react-icons/fa";
import "./PageHeader.css";
// import { backArrow_icon } from "../../assets/img/imgIndex";
// import usePermission from "../../customHook/usePermission";
import usePermission from "../customHook/usePermission"
import Header from "../Header";
const PageHeader = ({
  title,
  buttonText,
  onButtonClick,
  buttonPath,
  showBackButton = false,
  onBackClick,
  permissionAllowed,
}) => {
  const navigate = useNavigate();

  const permission = usePermission();

  const handleButtonClick = () => {
    if (onButtonClick) {
      onButtonClick();
    } else if (buttonPath) {
      navigate(buttonPath);
    }
  };

  const handleBackClick = () => {
    if (onBackClick) {
      onBackClick();
    } else {
      navigate(-1);
    }
  };

  return (

    <div className="page-header">
      <div className="page-header-left">
        
        {showBackButton && (
          <button className="back-button" onClick={handleBackClick}>
            {/* <img
              src={backArrow_icon}
              alt="Back Arrow"
              style={{ width: "100%", height: "100%" }}
            /> */}
          </button>
        )}
        <h1 className="page-title">{title}</h1>
      </div>
      {buttonText && permission?.includes(permissionAllowed) && (
        <button className="header-action-btn" onClick={handleButtonClick}>
          {buttonText}
        </button>
      )}
    </div>
  );
};

export default PageHeader;
